import { render, staticRenderFns } from "./SidenavComponent.vue?vue&type=template&id=048b2306&"
import script from "./SidenavComponent.vue?vue&type=script&lang=js&"
export * from "./SidenavComponent.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/libs/perfect-scrollbar/perfect-scrollbar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048b2306')) {
      api.createRecord('048b2306', component.options)
    } else {
      api.reload('048b2306', component.options)
    }
    module.hot.accept("./SidenavComponent.vue?vue&type=template&id=048b2306&", function () {
      api.rerender('048b2306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavComponent.vue"
export default component.exports